/**
 * @deprecated — This file is a backward-compatible facade.
 * Prefer importing directly from:
 *   - `@/shared/store/language-store` (store + getters)
 *   - `@/shared/composables/useLanguageSync` (reactive sync)
 *   - `@/shared/services/providers/language-utils` (pure utilities)
 */
import { useLanguageStore } from "@/shared/store/language-store";
import { LanguageWithWildcard } from "@/shared/services/graphql/generated/consumer-graph-types";

/**
 * @deprecated Use `useLanguageStore().setUiLanguage(locale)` directly.
 */
export function setUiLanguage(uiLang: string) {
    const store = useLanguageStore();
    store.setUiLanguage(uiLang);
}

// --- Deprecated getter wrappers — use store computed properties directly ---

/** @deprecated Use `useLanguageStore().uiLocale` */
export function getUiLanguage(): string {
    return useLanguageStore().uiLocale;
}

/** @deprecated Use `useLanguageStore().databaseLocale` */
export function getDatabaseLanguage(): string {
    return useLanguageStore().databaseLocale;
}

/** @deprecated Use `useLanguageStore().fallbackLocales` */
export function getFallbackLanguages(): string[] {
    return useLanguageStore().fallbackLocales;
}

/** @deprecated Use `useLanguageStore().dataQueryLanguages` */
export function getDataQueryLanguages(): LanguageWithWildcard[] {
    return useLanguageStore().dataQueryLanguages;
}

/** @deprecated Use `useLanguageStore().availableLocales` */
export function getAvailableLanguages(): string[] {
    return useLanguageStore().availableLocales;
}
